
import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';

interface ToggleableSectionProps {
  title: string;
  isVisible: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const ToggleableSection = ({ title, isVisible, onToggle, children }: ToggleableSectionProps) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-white">{title}</h3>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onToggle}
          className="text-gray-400 hover:text-white"
        >
          {isVisible ? (
            <>
              <EyeOff className="h-4 w-4 mr-2" />
              Hide {title.split(' ')[0]}
            </>
          ) : (
            <>
              <Eye className="h-4 w-4 mr-2" />
              Show {title.split(' ')[0]}
            </>
          )}
        </Button>
      </div>

      {isVisible ? (
        children
      ) : (
        <div className="bg-gray-900 px-6 py-8 rounded-lg border-2 border-gray-600 text-center">
          <Eye className="w-12 h-12 text-gray-500 mx-auto mb-4" />
          <p className="text-gray-400 text-lg">Click "Show {title.split(' ')[0]}" above to reveal your {title.toLowerCase()}</p>
        </div>
      )}
    </>
  );
};

export default ToggleableSection;
